/**
 * ActionTypes
 */
export enum ActionTypes {
  CHANGE_SPINNER = 'CHANGE_SPINNER',
  CHANGE_ALERT = 'CHANGE_ALERT',
}

/**
 * Components Types
 */
export type TSpinner = {
  show?: boolean
  remove?: boolean
}

export type TAlert = {
  show: boolean
  status: number
  message: string
}

/**
 * Actions
 */
export interface IChangeSpinnerAction {
  type: ActionTypes.CHANGE_SPINNER
  payload: TSpinner
}

export interface IChangeAlertAction {
  type: ActionTypes.CHANGE_ALERT
  payload: TSpinner
}

/**
 * Root State
 */
export type TState = {
  spinner: TSpinner
  alert: TAlert
}

/**
 * Root Action
 */
export type TActionTypes = IChangeSpinnerAction | IChangeAlertAction
